import ShipmentsContainer from "./ShipmentsContainer";
export default ShipmentsContainer;
